import React from 'react'
import Landingpage from './Landingpage'
import Benifitinvesting from './Benifitinvesting'
import ContactUs from './contactus'
import Testimonial from './Testimonial'
import Landinganimation from './Landinganimation'
import Subscriptionsection from './Subscriptionsection'

import WelcomeImage from './WelcomeImage'
import AutoLogin from '../auth/AutoLogin'

const Homepage = () => {
  return (

    <>

      <AutoLogin />
      <Landingpage />
      <WelcomeImage />
      {/* <Landinganimation/> */}
      <Benifitinvesting />
      <Subscriptionsection />
      <Testimonial />
      <ContactUs />

    </>
  )
}

export default Homepage